import videoPreview from 'common/components/video-preview/video-preview.vue';

export default {
	components: {
		videoPreview
	}
};
